/* eslint-disable @typescript-eslint/no-explicit-any */
export interface HttpRequest {
  url: string
  method: HttpMethod
  body?: any
  headers?: any
}

export interface HttpClient<R = any> {
  request: (data: HttpRequest) => Promise<HttpResponse<R>>
}

export type HttpMethod = 'post' | 'get' | 'put' | 'delete'

export enum HttpStatusCode {
  ok = 200,
  created = 201,
  noContent = 204,
  badRequest = 400,
  unauthorized = 401,
  forbidden = 403,
  notFound = 404,
  serverError = 500,
  failedPreCondition = 412
}

export interface HttpResponse<T = unknown> {
  statusCode: HttpStatusCode
  body?: T
}

export class UnexpectedError extends Error {
  name: string
  message: string
  cause: any

  constructor(message: string) {
    super()
    this.name = 'UnexpectedError'
    this.message = message
  }
}

export class NotFoundError extends Error {
  name: string
  message: string
  cause: any

  constructor(message: string) {
    super()
    this.name = 'NotFoundError'
    this.message = message
  }
}

export class ForbiddenError extends Error {
  name: string
  message: string
  cause: any

  constructor(message: string) {
    super()
    this.name = 'ForbiddenError'
    this.message = message
  }
}
